module.exports = __webpack_public_path__ + "img/image-14.9a9727df.png";